/// <reference path="MiniMeSpeechBubble.js" />
/// <reference path="GenericSounds.js" />

var ColorSelectorActiveColor = null;

class ColorSelector {
	constructor(editor, colors, width, height, vertical, feedback, speechBubble) {
		this.colors = [];
		this.height = 0;
		this.width = 0;
		this.namespace = "http://www.w3.org/2000/svg";
		this.mouseUpHappened = true;
		this.activeElement = null;
		this.editor = editor;
		this.colors = colors;
		this.width = width;
		this.height = height;
		this.playFeedbackSound = feedback;
		this.speechBubble = speechBubble;

		if (GenericSoundsInstance == null) {
			new GenericSounds(this.playFeedbackSound);
		}

		if (vertical) {
			this.drawVerticalSelector();
		}
	}

	drawVerticalSelector() {
		var colorsCount = this.colors.length;
		var boxHeight = this.height / colorsCount;
		var boxWidth = boxHeight;

		for (var i = 0; i < colorsCount; i++) {
			var r = boxWidth / 2;
			var x = this.width - boxWidth - 20 + r;
			var y = i * boxHeight + r;

			var color = document.createElementNS(this.namespace, "circle");
			color.setAttribute("cx", x);
			color.setAttribute("cy", y);
			color.setAttribute("r", r - 1);
			color.style.fill = this.colors[i];
			color.style.stroke = this.colors[i];
			color.style.strokeWidth = 2;
			color.onclick = this.colorClickHandler.bind(this);
			color.onmousedown = function(e) {
				this.mouseUpHappened = false;
			}.bind(this);
			color.onmouseup = function(e) {
				this.mouseUpHappened = true;
			}.bind(this);
			color.onmouseout = function(e) {
				if (!this.mouseUpHappened) {
					this.speechBubble.show(MiniMeSpeechBubbles["colors"]);
				}
			}.bind(this);
			this.editor.getElementById("colorSelector").appendChild(color);
		}
	}

	resetColors() {
		if (this.activeElement != null) {
			this.activeElement.setAttribute("cx", (parseFloat(this.activeElement.getAttribute("cx")) + 20));
			this.activeElement.style.stroke = this.activeElement.style.fill;
			this.activeElement = null;
		}
		ColorSelectorActiveColor = null;
	}

	colorClickHandler(e) {
		GenericSoundsInstance.putDownSound();
		this.resetColors();

		var selectedColorElement = e.target;

		ColorSelectorActiveColor = selectedColorElement.style.fill;
		selectedColorElement.setAttribute("cx", selectedColorElement.getAttribute("cx") - 20);
		selectedColorElement.style.stroke = "#000000";
		selectedColorElement.style.x -= 20;
		this.activeElement = selectedColorElement;
	}
}
